<template>
  <div class="tile is-ancestor is-vertical box is-12 zeromp">
    <div class="tile is-parent is-12 zeromp">
      <article class="tile is-child zeromp">
        <div class="content zeromp">
          <internnavbar />
        </div>
      </article>
    </div>
    <div class="tile is-vertical is-12 internbackground">
      <div class="tile is-parent is-vertical">
        <div class="tile is-child">
          <p class="indextitle">MATERIAL</p>
          <b-button @click="configSearch(); showFiltersBar()" class="lupabusca">
            <i class="fas fa-search dp-none"></i>
          </b-button>
          <b-button @click="hideFiltersBar" class="lupabusca closeLupa">
            <i class="fas fa-times dp-none"></i>
          </b-button>

          <div class>
            <div class id="tabela-material">
              <b-button
                v-if="is_admin"
                class="is-white"
                tag="router-link"
                to="material/create"
                type="is-link"
              >ADICIONAR NOVO MATERIAL</b-button>
              <b-table 
                :data="isEmpty? [] : materialsPaginate" 
                :hoverable="true" 
                paginated
                backend-pagination
                @page-change="onPageChange"
                @filters-change.prevent="show();"
                :total="total"
                :per-page="per_page">
                <template slot-scope="props">
                  <!-- colunas-->

                  <input type="hidden" :id="props.row.id"/>

                  <b-table-column v-if="props.row.file" label="Título" field="file.titulo" searchable>{{ props.row.file.titulo }}</b-table-column>

                  <b-table-column v-if="props.row.file" label="Descrição" field="file.descricao" searchable>{{ props.row.file.descricao }}</b-table-column>

                  <b-table-column label="Escolas">
                    <span v-if="! Object.keys(props.row.escolas).length">Aberto</span>
                    <b-select v-else :placeholder="`Escolas disponiveis`" expanded>
                      <option
                        v-for="(obj) in props.row.escolas"
                        v-bind:key="obj.id"
                        :value="obj.id"
                      >{{ obj.nome }}</option>
                    </b-select>
                  </b-table-column>

                  <b-table-column label="Tags" field="tags">
                      <b-tag type="is-info"
                        v-for="(tag, key) in props.row.tags"
                        v-bind:key="key"
                        :value="key"
                      >{{ tag.nome }}</b-tag>
                  </b-table-column>

                  <b-table-column field="actions" label="Ações" width="180" centered>
                    <!-- detalhes -->
                    
                    <b-tooltip label="Abrir" position="is-top" type="is-dark">
                      <a v-bind:href="props.row.file.url" target="_blank">
                        <button
                          class="button is-primary is-round"
                          id="info"
                        >
                          <b-icon icon="eye"></b-icon>
                        </button>
                      </a>
                    </b-tooltip>
                    <!-- editar -->
                    <b-tooltip label="Editar" position="is-top" type="is-dark">
                      <router-link
                        :to="{ name: 'material/update', params: { uuid: props.row.id }}"
                      >
                        <button class="button is-primary is-round" id="edit">
                          <b-icon icon="pencil"></b-icon>
                        </button>
                      </router-link>
                    </b-tooltip>
                      <!-- deletar -->
                    <b-tooltip label="Deletar" position="is-top" type="is-dark" >
                      <button
                        class="button is-primary is-round"
                        id="delete"
                        @click="deleteMaterial(props.row.id)"
                      >
                        <b-icon icon="delete-outline"></b-icon>
                        </button>
                    </b-tooltip>
                  </b-table-column>
                </template>
                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <i class="fas fa-frown-open" style="width:5em;height:5em;"></i>
                      </p>
                      <p>Nada aqui.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <internfooter />
      </div>
    </div>
  </div>
</template>

<script>
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import MaterialService from "@/services/MaterialService";

export default {
  data() {
    return {
      isEmpty: false,
      materialMobile: {},
      isImageModalActive: false,
      isCardModalActive: false,
      fileUrl:"",
      materialsPaginate: this.materials.data,
      total: this.materials.total,
      per_page: this.materials.per_page
    };
  },

  name: "TableMaterial",
  props: ["materials", "is_admin"],
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter
  },
  watch: {
    materials: function(newMaterials){
      this.materialsPaginate = newMaterials.data;
      this.total = newMaterials.total,
      this.per_page = newMaterials.per_page
    }
  },
  methods: {
    onPageChange(page, titulo, descricao) {
      MaterialService.Index(this.$route.meta.cargo, this.$route.meta.cargoId, page, titulo, descricao).then(result => {
        this.materialsPaginate = Object.values(result.data);
      });
    },
    configSearch(){
      this.tableOverrideInputs(
        document.getElementsByClassName("table")[0],
        this.search,
        [0, 1]
      );
    },
    search(){
      let p = document.getElementsByClassName("table")[0].firstElementChild.lastElementChild.getElementsByTagName('input');
      this.onPageChange(1, p[0].value, p[1].value);
    },
    deleteMaterial(uuid) {
      this.serviceDelete(
        "Você tem certeza que deseja deletar esse material?", 
        "Material deletado com sucesso", 
        MaterialService.Delete, 
        uuid,
        this.$buefy.toast,
        document.getElementById(uuid).parentNode
      );
    }
  }
};
</script>
<style scoped>
iframe {
  height: 60vh;
}
</style>